import script from "./ApplyCreateView.vue?vue&type=script&setup=true&lang=js"
export * from "./ApplyCreateView.vue?vue&type=script&setup=true&lang=js"

import "./ApplyCreateView.vue?vue&type=style&index=0&id=2070a25c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2070a25c"]])

export default __exports__